if (!customElements.get('review-gallery-modal')) {
  customElements.define(
    'review-gallery-modal',
    class ReviewGalleryModal extends ModalDialog {
      constructor() {
        super();
        this.items = Array.from(this.querySelectorAll('.review-gallery-modal__item'));
        this.prevButton = this.querySelector('.review-gallery-modal__nav--prev');
        this.nextButton = this.querySelector('.review-gallery-modal__nav--next');
        this.currentIndex = 0;

        this.prevButton?.addEventListener('click', () => this.step(-1));
        this.nextButton?.addEventListener('click', () => this.step(1));
        this.addEventListener('keydown', this.onKeydown.bind(this));

        // ModalDialog's own click-to-close only fires when the click lands
        // exactly on this element, which the centering wrapper can prevent.
        // Close on anything that isn't the image itself or a control.
        this.addEventListener('click', (event) => {
          if (!event.target.closest('.review-gallery-modal__image, .review-gallery-modal__nav, .review-gallery-modal__toggle')) {
            this.hide();
          }
        });
      }

      show(opener) {
        super.show(opener);
        const targetId = opener?.getAttribute('data-media-id');
        const index = this.items.findIndex((item) => item.dataset.mediaId === targetId);
        this.setActive(index > -1 ? index : 0);
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      }

      step(direction) {
        this.setActive(this.currentIndex + direction);
      }

      setActive(index) {
        if (index < 0 || index >= this.items.length) return;

        this.currentIndex = index;
        this.items.forEach((item, i) => item.classList.toggle('active', i === index));
        this.prevButton?.toggleAttribute('disabled', index === 0);
        this.nextButton?.toggleAttribute('disabled', index === this.items.length - 1);
      }
    }
  );
}
